export default __webpack_public_path__ + "static/media/708.58c00188.png";